import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-miscellaneous-sanctional-orders',
  templateUrl: './miscellaneous-sanctional-orders.component.html',
  styleUrls: ['./miscellaneous-sanctional-orders.component.css']
})
export class MiscellaneousSanctionalOrdersComponent implements OnInit {
  OrderData:any
  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getDetails()
  }

  getDetails() {
    const url = this.global.basePath + "common/circularlist?modelType=miscellaneousSanctionOrders";
    this.global.GetRequestUnauthorised(url).subscribe((res:any) => {
      const data = res[0].json.circular;
      this.OrderData = data;
    });
  }

  toLink(link:any){
    if(!link.includes('api.')){
      link= this.global.basePathImage+link;
    }
    window.open(link,'_blank')
  }

}
